<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="title">3天CP·爱在进行时</div>
      <div class="declaration">
        人生海海<br>总会有一个人会成为你的信徒<br>穿越茫茫人海与你一见如故<br>
        陪你见证宇宙山河浪漫，人间点滴温暖<br>在这里，开启你的邂逅之旅吧
      </div> -->
      <img class="pic-title" src="https://static.huiyiji520.com/cppic-1661943120.png">
      <img class="pic-declaration" src="https://static.huiyiji520.com/cppic-1661823673.png">
      <div class="btn-groupon two flex-box" @click="proposeGroupon(2)" :style="{color: getBtnColor('two'), backgroundColor: getBtnBackground('two')}">双人拼团<span class="discount">8折</span></div>
      <div class="btn-groupon three flex-box" @click="proposeGroupon(3)" :style="{color: getBtnColor('three'), backgroundColor: getBtnBackground('three')}">三人拼团<span class="discount">6折</span></div>
      <div class="btn-groupon single flex-box" @click="proposeSingle()" :style="{color: getBtnColor('single'), backgroundColor: getBtnBackground('single')}">单人报名</div>
      <div class="groupon-rule" @click="openPop">拼团规则</div>

      <van-popup class="pop-groupon" v-model="showPop" round position="center" :close-on-click-overlay="false">
        <div>
          <div class="group-title">拼团规则</div>
          <div class="group-rule">1. 用户可以发起/参与双人拼团或三人拼团（拼团优惠不可与其它代金券叠加使用）</div>
          <div class="group-rule">2. 拼团发起人支付单人费用以后，将拼团页面截图发给其他人，其他人加入拼团并支付费用。</div>
          <div class="group-rule">3. 拼团付款人数达标以后，拼团用户可填写报名表，提交活动报名信息。</div>
          <div class="group-rule">4. 拼团付款人数未达标前，发起人可申请取消拼团，系统会退还实际付款金额至付款用户实际支付账户。</div>
          <div class="group-rule">5. 拼团成员全部完成付款后，拼团成功，即可补充填写报名资料。</div>
          <div class="btn-know" @click="closePop()">我知道了</div>
        </div>
      </van-popup>

    </div>
  </div>
</template>

<script>
import { Dialog, Popup } from 'vant'

export default{
  components: {
    [Dialog.name]: Dialog,
    [Popup.name]: Popup
  },
  data(){
    return {
      capacity: 0,
      showPop: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    proposeGroupon(capacity){
      // console.log('proposeGroupon: ' + capacity)
      let searchParams = new URLSearchParams(window.location.search)
      let referal = searchParams.get("referal") ? searchParams.get("referal") : "matrix"
      // this.$store.commit('setReferal', { referal: referal })
      // this.capacity = capacity
      // this.$store.commit('updateGroupCapacity', {capacity: capacity})
      // this.$store.commit('updateGroupPaytype', {pay_type: "create"})
      this.handleRouter(`/groupon_choose_sex?groupon_params=${referal}*${capacity}*create`)
    },
    proposeSingle(){
      let searchParams = new URLSearchParams(window.location.search)
      let referal = searchParams.get("referal") ? searchParams.get("referal") : "matrix"
      // alert('goNext referal: ' + referal)
      this.handleRouter('/choose_me_sex?referal=' + referal)
    },
    getBtnColor(capacity){
      return this.capacity == capacity ? '#fff' : '#000'
    },
    getBtnBackground(capacity){
      return this.capacity == capacity ? '#f1b8af' : '#fff'
    },
    getBorderColor(capacity){
      return this.capacity == capacity ? '#f1b8af' : '#000'
    },
    openPop(){
      this.showPop = true
    },
    closePop(){
      this.showPop = false
    },
    closeEnroll(){
      Dialog.confirm({
        message: '活动报名已结束，下期报名尚未开始，敬请期待！',
        showConfirmButton: false,
        showCancelButton: false
      })
      .then(() => {
        // on confirm
      })
      .catch(() => {
        // on cancel
      });
    },
    checkeCurrentStage(){
      let searchParams = new URLSearchParams(window.location.search)
      let referal = searchParams.get("referal") ? searchParams.get("referal") : "matrix"
      let stage = this.$store.state.currentStage
      if(stage != "enrolling" && stage != "matching"){
        this.closeEnroll()
      }
    }
  },
  mounted(){
    this.checkeCurrentStage()
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  /* background-image: url("https://static.huiyiji520.com/cponline-1659166921.jpg"); */
  /* background-image: url("https://static.huiyiji520.com/bg-1661137902.png"); */
  background-image: url("https://static.huiyiji520.com/cppic-1661150074.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
/* .main .title{margin-top:200px;margin-bottom:113px;font-size:70px;color:#eb8e80;font-weight:bold;font-family:'NotoSerifSCBlack';}
.main .declaration{font-size:40px;line-height:80px;color:#737373;margin-bottom:113px;} */
/* position:fixed;bottom:200px;left:0;right:0; */
.main .pic-title{width:202px;height:65px;margin:0 auto;margin-top:150px;margin-bottom:90px;}
.main .pic-declaration{width:704px;height:445px;margin:0 auto;margin-bottom:100px;}
.main .btn-me{
  width:342px;height:90px;font-size:40px;border:5px solid #f1b8af;border-radius:30px;
  margin:0px auto;color:#ffffff;background:#f1b8af;justify-content:center;
}
.main .btn-groupon{
  width:350px;height:90px;font-size:30px;border:2px solid black;
  margin:0px auto;justify-content:center;margin-bottom:50px;color:#000;
}
.main .btn-groupon .discount{color:#ff7777;margin-left:20px;}
.main .groupon-rule{font-size:30px;text-decoration:underline;font-weight:normal;color:#000;}
.pop-groupon{font-size:30px;width:75%;padding:30px;color:#000;}
.pop-groupon .group-title{font-weight:bold;margin-bottom:25px;}
.pop-groupon .group-rule{font-size:25px;text-align:left;margin-bottom:15px;}
.pop-groupon .btn-know{
  background:#000;color:#fff;width:200px;height:60px;line-height:60px;font-size:28px;
  margin:0px auto;
}
</style>
